<app-auto-reg-items></app-auto-reg-items>
